export default "__VITE_ASSET__8QtpHPtz__"